import React from 'react';
// import './HelpAssistant/HelpAssistant.css';
import toastIcon from "../images/icons/toast-info.svg"

const RechargeToast = (props) => {

    const data= props.item && props.item.data && JSON.parse(props.item.data)
    const text = data && data.text;
    const url= data && data.url;
    // console.log("rechargeprops",props)



    return (
        <div className="top-offers chat-offers" style={{display: 'block'}}>
         <div className="offer-content">
             <div>
                 <div className="toast-message">
                     <div className="desc-txt">
                         <span><img src={toastIcon} alt="Logo" title="Logo" className="img-fluid" style={{marginRight:'10px'}}/></span>
                         <div className="toast-text">
                            <div className="txt">{text}</div>
                            <a href={url || '#'} className="link" target="_blank" 
                                       onClick={()=>{props.handleClick(props.item.text);props.setTextOnClick(props.item.text)}}
                            >Recharge</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    )
}


export default RechargeToast